import * as moment from 'moment';
import { Subscription } from '../models/plans';

export const formatPlanRemainingTime = (subscription?: Subscription): string => {
  if (!subscription) {
    return '';
  }
  const expirationDate = moment(subscription.periodEnd);
  const hours = expirationDate.diff(moment(), 'hours');
  const notificationLabel = moment.duration(hours, 'hours').humanize();
  const [planRemainingTime, planRemainingTimeUnit] = notificationLabel.split(' ');
  return `${planRemainingTime} ${planRemainingTimeUnit}`;
};

export const subscriptionExpired = (subscription?: Subscription): boolean => {
  if (!subscription) {
    return true;
  }
  return moment(subscription.periodEnd).isBefore(moment());
};
